import { shuffle } from 'lodash';

/**
 * Creates an array of numbers in a random order, like a deck of cards.
 * @param {number} itemCount The number of "cards" in the "deck".
 * @returns {number[]} An array of numbers, starting with 1, in a random order.
 */
const makeShuffledArray = (itemCount) => {
  const result = [];
  for (let i = 0; i < itemCount; i += 1) {
    result.push(i + 1);
  }
  return shuffle(result);
};

export default makeShuffledArray;
